export const testimonials = [
  {
    name: "Vikas Bhagat",
    review: "One of the best coaching classes for CAT exams. The MBA class environment is motivating and Prasad Sir is always ready to clear doubts any time. Definitely recommended CAT classes near Kalyan.",
    course: "MBA CET / CAT",
    rating: 5,
  },
  {
    name: "Radha Jaiswal",
    review: "Before joining it was very difficult to understand the Railway NTPC syllabus but after attending a few lectures, every subject became easy to solve. Totally worth joining classes for Railway exam coaching.",
    course: "Railway NTPC",
    rating: 5,
  },
  {
    name: "Prathmesh Kulkarni",
    review: "I enrolled in offline and online classes for both Bank Clerk and Bank PO exam course. Learned so many shortcuts, it really helps saving time in Bank PO exam.",
    course: "Banking (IBPS PO/Clerk)",
    rating: 5,
  },
  {
    name: "Komal Raut",
    review: "The Banking and MBA CET coaching here is just superb. The tricks are simple to remember which helps solving Maths and Reasoning quickly.",
    course: "Banking & MBA CET",
    rating: 5,
  },
  {
    name: "Sandhya Patil",
    review: "Honestly best IBPS classes near Ambernath. Teachers explain every concept clearly and the regular lectures and tests helped me gain confidence in IBPS Clerk and PO exam.",
    course: "IBPS Clerk/PO",
    rating: 5,
  },
  {
    name: "Rishav Kumar",
    review: "I am enjoying each and every subject of SSC CGL exam taught in this class. All the topics are taught by teachers in shortcuts. Algebra, Geometry and Trigonometry are now easy to solve.",
    course: "SSC CGL",
    rating: 5,
  },
  {
    name: "Soni Lashkar",
    review: "Amazing coaching classes, provided best study materials, mock tests and guidance for the government exam and Railway exam preparation.",
    course: "Railway Exams",
    rating: 5,
  },
  {
    name: "Kk Singh",
    review: "Great environment and talented faculties given easy method to solve Maths and Reasoning for Banking, MBA CET and CAT.",
    course: "Banking & MBA",
    rating: 5,
  },
  {
    name: "Dakshata Kokam",
    review: "Definitely this banking coaching class is the best place to study specially for IBPS PO and SBI PO exams. The faculty support is incredible.",
    course: "IBPS PO / SBI PO",
    rating: 5,
  },
];

export const whyChooseUs = [
  {
    title: "360 Hybrid Doubt Support",
    description: "Offline face-to-face sessions with faculty for immediate clarity. Online digital access to teachers and resources during self-study hours.",
    icon: "HeadphonesIcon",
  },
  {
    title: "Selection-Centric Mentorship",
    description: "Complete guidance through Prelims, Mains, and Interview stages. Post-exam analysis to ensure success in the next attempt.",
    icon: "Target",
  },
  {
    title: "Smart Learning Environment",
    description: "AC Classrooms for focused 4-6 hour study marathons. Digital Boards for interactive visuals and better memory retention.",
    icon: "MonitorSmartphone",
  },
  {
    title: "Student-First Approach",
    description: "Regular progress tracking for every student. Focus on Shortcuts, Vedic Math, and Time-Management tricks for high-pressure cut-offs.",
    icon: "UserCheck",
  },
  {
    title: "Updated Exam Patterns",
    description: "Notes and test series updated in real-time for latest IBPS, SSC, and CET pattern changes. Logic-based coaching beyond rote learning.",
    icon: "RefreshCw",
  },
  {
    title: "The Vedanti Advantage",
    description: "In-House Library, prime location near Badlapur Station, and regular motivational counseling to keep morale high.",
    icon: "Award",
  },
];
